import EmailTemplatesReducer from "./emailTemplates/reducer";
import { combineReducers } from "redux";

// Layout
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import OtpLoginReducer from "./auth/otpLogin/reducer";

// Support Tickets
import TicketsReducer from "./tickets/reducer";

// Invoice
import InvoiceReducer from "./invoice/reducer";

// Profile Data
import ProfileDataReducer from "./profile/profileSlice";

// Help
import HelpReducer from "./help/helpSlice";

// Plans
import PlansReducer from "./plans/plansSlice";

// Admin
import AdminReducer from "./admin/reducer";

// Reminders
import RemindersReducer from "./reminders/reducer";

// Portal
import PortalReducer from "./portal/reducer";

// Notifications
import NotificationsReducer from "./notifications/reducer";

// WhatsApp Credits
import WhatsAppReducer from "./whatsapp/reducer";

// Website Builder
import WebsiteBuilderReducer from "./websiteBuilder/reducer";

// LeadWix 2.0 Phase 1
import LeadsReducer from "./leads/reducer";
import PipelineReducer from "./pipeline/reducer";
import WidgetsReducer from "./widgets/reducer";
import LeadFormsReducer from "./leadForms/reducer";
import BookingsReducer from "./bookings/reducer";

// LeadWix 2.0 Phase 2
import InboxReducer from "./inbox/reducer";
import SequencesReducer from "./sequences/reducer";

// LeadWix 2.0 Phase 3 — Wisp AI
import AIReducer from "./ai/reducer";

// LeadWix 2.0 Phase 5 — Affiliate
import AffiliateReducer from "./affiliate/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    OtpLogin: OtpLoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Tickets: TicketsReducer,
    Invoice: InvoiceReducer,
    EmailTemplates: EmailTemplatesReducer,
    ProfileData: ProfileDataReducer,
    Help: HelpReducer,
    Plans: PlansReducer,
    Admin: AdminReducer,
    Reminders: RemindersReducer,
    Portal: PortalReducer,
    Notifications: NotificationsReducer,
    WhatsApp: WhatsAppReducer,
    WebsiteBuilder: WebsiteBuilderReducer,
    Leads: LeadsReducer,
    Pipeline: PipelineReducer,
    Widgets: WidgetsReducer,
    LeadForms: LeadFormsReducer,
    Bookings: BookingsReducer,
    Inbox: InboxReducer,
    Sequences: SequencesReducer,
    AI: AIReducer,
    Affiliate: AffiliateReducer
});

export default rootReducer;